import { useIntl } from 'react-intl'
import * as Yup from 'yup'

export const passwordSchema = () => {
  // todo: fix this
  // eslint-disable-next-line
  const { formatMessage } = useIntl()
  return Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .test(
      'reject Password If Match Regex without number',
      formatMessage({
        defaultMessage: 'Password must contain a number',
      }),
      (value) => {
        return !value?.match(/^[a-zA-Z\s\D]+$/)
      }
    )
    .test(
      'reject Password If Match Regex without special character',
      formatMessage({
        defaultMessage: 'Password must contain a special character',
      }),
      (value) => {
        return !value?.match(/^[a-zA-Z\s\d]+$/)
      }
    )
}

export const emailSchema = (isRequired: boolean = true) => {
  // todo: fix this
  // eslint-disable-next-line
  const { formatMessage } = useIntl()

  // Match backend validator to avoid backend errors.
  // From https://github.com/colinhacks/zod/blob/a57fc2da3c48a5a2270e9684017d8bc056af8a40/src/types.ts#L523
  const zodEmailRegex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i

  const emailMatch = Yup.string()
    .matches(
      zodEmailRegex,
      formatMessage({
        defaultMessage: 'Please enter a valid email address',
      })
    )
    .test(
      'Reject email if ends in .con',
      formatMessage({
        defaultMessage: "An email address cannot end in '.con'",
      }),
      (value) => {
        return !value?.match(/\.con$/)
      }
    )
  return isRequired
    ? emailMatch.required(
        formatMessage({ defaultMessage: 'Email address cannot be empty' })
      )
    : emailMatch
}
